
import debug from 'bows/dist/bows.min.js';

const log = debug("sliders:helper");
window.sliderArray = [];

window.wdgSliderToVisible = function (loadSlide) {
	window.sliderArray.forEach(slide => {
		let current = 0;
		if (loadSlide) {
			current = loadSlide;
		} else {
			current = slide.slick('slickCurrentSlide');
		}
		slide.slick('slickGoTo', current, true);
	})
}
export function init() {
	log('SliderHelperInit');
}

export default {
	init
};